import { ShoppingCartState, ShoppingCartWithItems } from 'common-models';

export class ShoppingCart {
  public static getCurrentCartState(shoppingCart: ShoppingCartWithItems): ShoppingCartState {
    // const methodSignatureString = () => `${this.constructor.name}.getCurrentCartState('${JSON.stringify(shoppingCart)}')`;
    if (shoppingCart === undefined || shoppingCart.stateEvents === undefined || shoppingCart.stateEvents.length === 0) {
      return 'Unknown';
    }

    const sortedStates = [...shoppingCart.stateEvents];
    // sort descending

    sortedStates.sort((a, b) => {
      const result = new Date(b.time).valueOf() - new Date(a.time).valueOf();
      return result;
    });

    // return first item (which is the latest one)
    return sortedStates[0].state;
  }
}
